var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 3.33331C18.3327 3.33331 17.7493 5.08331 16.666 6.16664C17.9993 14.5 8.83268 20.5833 1.66602 15.8333C3.49935 15.9166 5.33268 15.3333 6.66602 14.1666C2.49935 12.9166 0.416016 7.99998 2.49935 4.16664C4.33268 6.33331 7.16602 7.58331 9.99935 7.49998C9.24935 3.99998 13.3327 1.99998 15.8327 4.33331C16.7493 4.33331 18.3327 3.33331 18.3327 3.33331Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAuthor);
export default __webpack_public_path__ + "static/media/x_author.8d562ba5a60857afcdb255b8d135caa2.svg";
export { ForwardRef as ReactComponent };